import gql from 'graphql-tag';
import { Trend360FullFragment } from '../fragments/Trend360FullFragment';

export const Trend360PatchMutation = gql`
	mutation Trend360PatchMutation($id: ID!, $changes: Trend360PatchInput!) {
		results: trend360Patch(id: $id, changes: $changes) {
			...Trend360FullFragment
		}
	}
	${Trend360FullFragment}
`;
